import { useRef, useState } from "react";

export const useStateWithDeps = <T,>(initialValue: () => T, deps: unknown) => {
  const [value, setValue] = useState(initialValue);
  const depsRef = useRef(deps);
  /**
   * プリミティブデータ型しかサポートしていない
   */
  // eslint-disable-next-line react-hooks/refs
  if (depsRef.current !== deps) {
    // eslint-disable-next-line react-hooks/refs
    depsRef.current = deps;
    setValue(initialValue);
  }
  return [value, setValue] as const;
};
